import { render, staticRenderFns } from "./viewMODEL.vue?vue&type=template&id=6ce672cf&scoped=true"
import script from "./viewMODEL.vue?vue&type=script&lang=js"
export * from "./viewMODEL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce672cf",
  null
  
)

export default component.exports